import ArticleService from '@/services/ArticleService'

const createArticlesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    articles: []
  },
  actions: {
    getArticles: ({ commit, state }) => {
      ArticleService.getArticles(state.pageSize, state.page, state.options)
        .then((data) => {
          commit('SET_ARTICLES', { articles: data.articles })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getArticles')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_ARTICLES: (state, { articles }) => {
      state.articles = articles
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createArticlesModule
